'use client';

import { Analytics } from '@vercel/analytics/next';
import { SpeedInsights } from '@vercel/speed-insights/next';
import { isVaultTelemetryURL, vaultTelemetryBlocked } from '@/lib/vault-telemetry';

export function DashboardPerformance() {
  return (
    <>
      <Analytics
        beforeSend={(event) =>
          vaultTelemetryBlocked() || isVaultTelemetryURL(event.url) ? null : event
        }
      />
      <SpeedInsights
        beforeSend={(event) =>
          vaultTelemetryBlocked() || isVaultTelemetryURL(event.url) ? null : event
        }
      />
    </>
  );
}
